import classNames from 'classnames';
import React, { ReactNode } from 'react';

import css from './BooksLoadingMask.module.scss';

interface Props {
  isLoading: boolean;
  children: ReactNode;
}

const BooksLoadingMask = ({ isLoading, children }: Props) => {
  const classes = classNames(css.BooksLoadingMask, {
    [css.isLoading]: isLoading,
  });

  return (
    <div className={classes}>
      {isLoading && <span className={css.BooksLoadingMask__Loading} />}
      <div className={css.BooksLoadingMask__Mask}>{children}</div>
    </div>
  );
};

export default BooksLoadingMask;
